import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import React, { useEffect, useState, useContext, } from "react";
import inviteCandidateResponse from "../../apis/inviteCandidate/inviteCandidate";
import getUserByEmailId from "../../apis/inviteCandidate/getUserByEmailId";
import getRecruiterAllTestsResponse from "../../apis/recruiterPrivateTestAccess/getRecruiterAllTest";
import { useLocation, useNavigate } from "react-router-dom";
import {
  NotificationManager,
} from "react-notifications";
// Lazy-load xlsx only when needed (do not import at module top-level)
import { FilePicker } from "react-file-picker";
import "./inviteCnadidates.css";
import Autocomplete from "@mui/material/Autocomplete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import validateEmail from "../../utilities/validateEmail";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import Header from "../../components/headerAdmin/Header";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { UserTypeContext } from "../../AppRoute";
import GetAppIcon from '@mui/icons-material/GetApp';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useParams } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import Tooltip from "@mui/material/Tooltip";
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess';
import CircularProgress from '@mui/material/CircularProgress';
import getVetJobDescription from '../../apis/vettest/getvetjd';
import getAllJobDescription from '../../apis/candidatescreening/getjd';
const styleSx = {
  buttonForSupport: {
    justifyContent: "flex-end !important",
    padding: "25px 30px 30px!important"
  },
  btnCancel: {
    width: "120px",
    height: "32px",
    backgroundColor: "#FFFFFF",
    color: "#1885E6",
    border: "1px solid #1885E6",
    paddingTop: '5px',
    fontSize: '15px',
    borderRadius: "3px",
    "&:hover": {
      opacity: "0.8",
      backgroundColor: "#D1E8FF"
    }
  },
  btnSave: {
    width: "120px",
    height: "32px",
    backgroundColor: "#1885E6",
    fontSize: '15px',
    color: "#FFFFFF",
    border: "1px solid #1885E6",
    paddingTop: '5px',
    borderRadius: "3px",
    "&:hover": {
      opacity: "0.8"
    }
  }
};

const InviteCandidates = (props) => {
  const location = useLocation();
  const { userType, userRecords } = useContext(UserTypeContext);
  const id = userType === 'Admin' ? location?.state?.id : userRecords?.id;
  const userRecruitmentpartnerId = userType === 'Admin' ? location?.state?.recruitmentPartnerId : userRecords?.recruitmentpartnerId;
  const userRole = location?.state?.userRole ? location?.state?.userRole : userRecords?.role?.roleName;
  const userRecrodData = userType === 'Admin' ? location?.state?.userRecords : userRecords;
  const { email } = useParams();
  const history = useNavigate();
  const [candidates, setCandidates] = useState([
    {
      firstName: "",
      lastName: "",
      email: "",
      chk: false,
      firstNameHighlight: false,
      lastNameHighlight: false,
      emailHighlight: false,
      aFocus: false
    },
  ]);

  const [allTests, setAllTests] = useState([]);
  const [allTestType, setallTestType] = useState(["Public", "Client-specific", "VET", "AI"]);
  const [testId, setTestId] = useState("");
  const [isInviteSend, setisInviteSend] = useState(false);
  const [selectedTest, setSelectedTest] = useState({});
  const [render, setRender] = useState(false);
  const [bulkUploadClick, setbulkUploadClick] = useState(false);
  const [confirmDeleteModal, setconfirmDeleteModal] = useState(false);
  const [submitloader, setSubmitloader] = useState(false);
  const [testType, setTestType] = useState("");
  const renderRecruiterSkill = async (recruiterId, type) => {
    try {
      const response = await getRecruiterAllTestsResponse(recruiterId);
      let isPublic = type === "Public" ? true : false;
      let skillArr = [];
      if (isPublic) {
        skillArr = response.data.data.filter(
          (e) => e.testtype.code === "Public"
        );
        setTestType("Public");
      } else {
        skillArr = response.data.data.filter(
          (e) => e.testtype.code !== "Public"
        );
        setTestType("Client-specific");
      }

      setAllTests(skillArr);
    } catch (error) {
      console.log(error);
    }
  };
  const userId = id;

  const handleSelect = (e, value) => {
    setTestId(value?.id || value?._id || "");
    if (value) {
      setSelectedTest(value);
    }
  };
  const addMoreForm = () => {
    if (!isInviteSend && candidates.length < 50) {
      const candidateObj = {
        firstName: "",
        lastName: "",
        email: "",
        chk: false,
        firstNameHighlight: false,
        lastNameHighlight: false,
        emailHighlight: false,
        aFocus: false
      };
      setCandidates([...candidates, candidateObj]);
    }
    if (candidates.length >= 50) {
      return NotificationManager.error(
        "A maximum of 50 candidates can be invited at once",
        "Error",
        10000
      )
    }
  };
  const addMoreForm1 = () => {
    if (!isInviteSend && candidates.length < 51) {
      const candidateObj = {
        firstName: "",
        lastName: "",
        email: "",
        chk: true,
        firstNameHighlight: false,
        lastNameHighlight: false,
        emailHighlight: false,
        aFocus: false
      };
      setCandidates([...candidates, candidateObj]);
    }
    if (candidates.length >= 51) {
      return NotificationManager.error(
        "A maximum of 50 candidates can be invited at once",
        "Error",
        10000
      )
    }
  };

  const highlightFieldChk = () => {
    let firstInvalid = null;

    const updated = candidates.map((candidate, index) => {
      const email = candidate.email?.trim() || "";
      const firstName = candidate.firstName?.trim() || "";
      const lastName = candidate.lastName?.trim() || "";
      const emailInvalid = email === "";
      const firstNameInvalid = firstName === "";
      const lastNameInvalid = lastName === "";
      if (
        firstInvalid === null &&
        (emailInvalid || firstNameInvalid || lastNameInvalid)
      ) {
        firstInvalid = { index, emailInvalid, firstNameInvalid, lastNameInvalid };
      }
      return {
        ...candidate,
        emailHighlight: emailInvalid,
        firstNameHighlight: firstNameInvalid,
        lastNameHighlight: lastNameInvalid,
      };
    });

    setCandidates(updated);
    return true;
  };

  const addMoreFo = (Data) => {
    for (let i = 0; i < Data.length; i++) {
      let candidateObj = {
        firstName: Data[i].FirstName === (undefined || null) ? "" : Data[i].FirstName,
        lastName: Data[i].LastName === (undefined || null) ? "" : Data[i].LastName,
        email: Data[i].Email === undefined ? "" : Data[i].Email,
        chk: false,
        firstNameHighlight: false,
        lastNameHighlight: false,
        emailHighlight: false,
      };
      setCandidates((prev) => [...prev, candidateObj]);
      for (let i = 0; i < candidates.length; i++) {
        handleCandidateEmailForm(candidates[i].email, i);
      }
    }
  };
  const closeExtraForm = (index) => {
    const remaining = [...candidates].filter((o, i) => i !== index);
    setCandidates(remaining);
  };

  const validateEmailResponse = async (email) => {
    let payload = {
      email: email,
    };
    try {
      const response = await getUserByEmailId(payload);
      const currentUser = response?.data?.data[0];
      let candidatesData = [...candidates];
      if (currentUser) {
        candidatesData = candidatesData.map(c => {
          if (c.email === currentUser.email) {
            c = { ...c, ...currentUser }
            if (currentUser.firstName !== "") c.disableFirstName = true;
            if (currentUser.lastName !== "") c.disableLastName = true;
          }
          return c;
        });
      }

      const result = candidatesData.map((e) => {
        if (e.disableFirstName ||
          e.disableLastName ||
          e.MiddleInitial ||
          e.countryCode ||
          e.phoneNumber ||
          e.profile) {
          delete e.MiddleInitial;
          delete e.countryCode;
          delete e.phoneNumber;
          delete e.profile;
        }
        return e;
      })
      setCandidates(result);
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleCandidateEmailForm = (val, i) => {
    let value = val;
    let name = "email"
    if (name === "email") {
      value = value.trim().toLowerCase();
    }
    const originalData = [...candidates];
    const changingData = originalData[i];
    changingData[name] = value;
    originalData[i] = changingData;
  };

  const handleCandidateEmailFormChange = (e, i) => {
    let { value, name } = e.target;
    if (name === "email") {
      value = value.trim().toLowerCase();
    }
    const originalData = [...candidates];
    const changingData = originalData[i];
    changingData[name] = value;

    if (value === "") {
      changingData.firstName = "";
      changingData.lastName = "";
      changingData.disableFirstName = false;
      changingData.disableLastName = false;
      changingData.emailHighlight = true
    }
    else {
      changingData.emailHighlight = false
    }
    originalData[i] = changingData;

    const emailValidate = validateEmail(value);
    setCandidates(originalData || []);
    if (emailValidate && value) {
      validateEmailResponse(value);
      changingData.firstName = "";
      changingData.lastName = "";
      changingData.disableFirstName = false;
      changingData.disableLastName = false;
    } else {
      changingData.firstName = "";
      changingData.lastName = "";
      changingData.disableFirstName = false;
      changingData.disableLastName = false;
    }
  };

  const handleCandidateFormChange = (e, i) => {
    let { value, name } = e.target;
    if (name === "email") {
      value = value.toLowerCase();
    }

    const originalData = [...candidates];
    const changingData = originalData[i];
    changingData[name] = value;
    originalData[i] = changingData;
    if (originalData[i].firstName !== "")
      originalData[i].firstNameHighlight = false
    if (originalData[i].lastName !== "")
      originalData[i].lastNameHighlight = false
    setCandidates(originalData || []);
  };

  const validate = () => {
    if (!testId || !userId) return false;

    return !candidates.some((c) => {
      const fields = [c.firstName, c.lastName, c.email];
      const filledCount = fields.filter(
        (f) => f && f.trim() !== ""
      ).length;
      return filledCount !== 3;
    });
  };

  const handleSendInviteCandidate = async (e) => {
    e.preventDefault();
    highlightFieldChk();
    //need to do validation for testId and userId    
    try {
      const isValidated = validate();
      if (!isValidated) {
        return NotificationManager.error(
          "Please fill all the mandatory fields",
          "Error",
          10000
        );
      } else {
        setSubmitloader(true);
        const commonData = {
          testTaken: false,
          testId,
          invitedBy: userId,
          createdBy: userId,
          updatedBy: userId,
          testType: testType,
          testLink: selectedTest?.id || selectedTest?.link || "",
          testTitle: selectedTest?.jobTitle || selectedTest?.title || selectedTest?.testName || "",
          testExpiryDate: selectedTest?.expiryAt || "",
        };
        const updateCandidates = [];
        for (let i = 0; i < candidates.length; i++) {
          if ((candidates[i].firstName !== "" && candidates[i].lastName !== "" && candidates[i].email !== "") || candidates[i].chk) {
            let candidateOb = {
              firstName: candidates[i].firstName,
              lastName: candidates[i].lastName,
              email: candidates[i].email,
            };

            updateCandidates.push(candidateOb)
          }
        }

        const payload = [...updateCandidates].map((c) => (
          { ...c, ...commonData }));

        const response = await inviteCandidateResponse(payload);
        const updatedArray = updateCandidates.map((o, i) => (
          {
            ...o,
            ...response.data.data[i],
          }
        ));

        setCandidates(updatedArray);
        setisInviteSend(true);
        setSubmitloader(false);
      }
    } catch (error) {

      if (error.response.status === 400) {
        setSubmitloader(false);
        const errorMessage = error.response.data.errMessage;
        NotificationManager.error(errorMessage, "Error", 10000);
      }
      console.log(error);
    }
  };
  const handleSelectSkillType = async (e, value) => {
    setSelectedTest({});
    if (value === "VET") {
      const testData = await getVetJobDescription({ recruitmentpartnerId: userRecruitmentpartnerId });
      setAllTests(testData?.data?.data);
      setTestType("vet");
      return
    }
    if (value === "AI") {
      const testData = await getAllJobDescription({ recruitmentpartnerId: userRecruitmentpartnerId, testinvite: true });
      const jobTitles = testData?.jobDescriptions?.map(test => test.jobTitle) || [];
      console.log("jobTitles", jobTitles);
      console.log("jobTitles\\", testData?.jobDescriptions);
      setAllTests(testData?.jobDescriptions);
      setTestType("AI");
      return
    }

    if (value) {
      renderRecruiterSkill(userId, value);
    } else {
      setSelectedTest({});
    }
  };

  const goToHomePage = () => {
    history("/dashboard",
      {
        state: {
          userType: userType,
          recruitmentPartnerId: userRecruitmentpartnerId,
          id: id,
          userRecords: userRecrodData,
          roleName: userRole
        }
      });
  };
  const formReset = () => {
    setbulkUploadClick(false)
    setTestId("");
    setisInviteSend(false);
    setallTestType(["Public", "Client-specific", "VET", "AI"]);
    setAllTests([]);
    setSelectedTest({});

    setCandidates(
      candidates.slice(0, 1).map((c) => ({
        ...c,
        firstName: "",
        lastName: "",
        email: "",
        status: "",
      }))
    );

    setRender(!render);
  };

  const bulk_upload_conf = () => {
    setconfirmDeleteModal(true)
  }
  const bulk_upload_cls = () => {
    setconfirmDeleteModal(false)
  }
  const bulk_upload_clr = () => {
    setconfirmDeleteModal(false)
    formReset();
  }
  const handelExcel = async (file) => {
    if (!file) return;

    let XLSX;
    try {
      XLSX = await import('xlsx');
    } catch {
      NotificationManager.error("Failed to load parser library", "Error", 5000);
      return;
    }

    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const workBook = XLSX.read(evt.target.result, { type: "buffer" });
        const sheet = workBook.Sheets[workBook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(sheet);

        if (!data.length) {
          NotificationManager.error(
            "Please fill the downloaded template and try again",
            "Error",
            10000
          );
          return;
        }

        const hasValidHeaders =
          data[0].FirstName !== undefined ||
          data[0].LastName !== undefined ||
          data[0].Email !== undefined;

        if (!hasValidHeaders) {
          NotificationManager.error(
            "Please use the correct template format",
            "Error",
            10000
          );
          return;
        }

        if (data.length + candidates.length > 50) {
          NotificationManager.error(
            "A maximum of 50 candidates can be invited at once",
            "Error",
            10000
          );
          return;
        }
        addMoreFo(data);
        setbulkUploadClick(true);

      } catch {
        NotificationManager.error("Failed to parse Excel file", "Error", 5000);
      }
    };

    reader.onerror = () => {
      NotificationManager.error("Failed to read file", "Error", 5000);
    };

    reader.readAsArrayBuffer(file);
  };


  useEffect(() => {

    if (email) {
      let obj = {
        target: {
          name: "email",
          value: email
        }
      }
      handleCandidateEmailFormChange(obj, 0)
    }
  }, [])

  return (
    <>
      <Header />
      {userType === "Recruiter" || userType === 'Recruitment Leader' || userType === 'MIS Operator' || userType === "Team Leader" || userType === "Organization Admin" ? (
        <>
          <div className="recruiter_invite_wrapper">
            <div className="communityHeader_inviteC">
              <div className="goBackButton" onClick={(e) => goToHomePage(e)}>
                <Tooltip title="Go Back to Dashboard" placement="bottom">
                  <ArrowBackIcon sx={{ fontSize: 20 }} />
                </Tooltip>
              </div>
              <div className="communityTitle">Invite Candidate to Take Test</div>
            </div>
            <p className="recruiter_invite_heading mt_20">
              Select Test to Invite Candidate
            </p>
            <hr className="recruiter_invite_divider"></hr>

            <div className="select customized-select dropdown_width_skill_recruiter_invite_skill">
              <div className="invite_candidate_skill_dropdown_wrapper_skilltype">
                <label className="recruiter_invite_label" htmlFor="Select Skill">
                  Test Type*
                </label>
                <Autocomplete
                  key={render}
                  id="combo-box-demo"
                  className="mt_15 selectfocus"
                  options={allTestType}
                  autoHighlight
                  disabled={isInviteSend}
                  getOptionLabel={(option) => option || ""}
                  onChange={handleSelectSkillType}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      required={true}
                      placeholder="Select Test Type"
                    />
                  )}
                />
              </div>
              <div className="invite_candidate_skill_dropdown_wrapper_skill">
                <label className="recruiter_invite_label" htmlFor="Select Skill">
                  Test*
                </label>
                <Autocomplete
                  key={render}
                  id="combo-box-demo"
                  className="mt_15"
                  options={allTests}
                  value={selectedTest}
                  autoHighlight
                  getOptionLabel={(option) => option?.jobTitle || option?.title || option?.testName || ""}
                  onChange={handleSelect}
                  disabled={isInviteSend}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      required={true}
                      placeholder="Select Test"
                    />
                  )}
                />
                <p className="client_info">
                  {selectedTest?.recruitmentpartner?.name
                    ? `Recruitment Organization : ${selectedTest?.recruitmentpartner?.name} `
                    : ""}
                  {selectedTest?.recruitmentpartner?.name &&
                    selectedTest?.customer?.name
                    ? ","
                    : ""}
                  {selectedTest?.customer?.name
                    ? ` Customer : ${selectedTest?.customer?.name}`
                    : ""}
                </p>
              </div>
            </div>
            <div className="invite_candidate_buttom_wrapper">
              <p className="recruiter_invite_heading">Add Candidates</p>
              <hr className="recruiter_invite_divider_two"></hr>
              <div className="invite_candidate_form_wrapper_main">
                <div className="df">
                  <div className="invite_candidate_label_wrapper">
                    <label className="recruiter_invite_label_form" htmlFor="fname">
                      Email*
                    </label>
                  </div>
                  <div className="invite_candidate_label_wrapper">
                    <label className="recruiter_invite_label_form" htmlFor="fname">
                      First Name*
                    </label>
                  </div>
                  <div className="invite_candidate_label_wrapper">
                    <label className="recruiter_invite_label_form" htmlFor="fname">
                      Last Name*
                    </label>
                  </div>
                </div>
                <div className="scrollbar" id="style-2">
                  <div className="invite_candidate_form_wrapper">
                    {candidates.map((candidate, i) => (
                      <div className="invite_candidate_form" key={i}>
                        <div className="select customized-select dropdown_width_recruiter_invite">
                          <input
                            type="text"
                            className={!candidate.emailHighlight ? "text_box_cleartalent_form_recruiter mt_8" : "text_box_cleartalent_form_recruiter_highlighter mt_8"}
                            placeholder="Enter Email"
                            name="email"
                            value={candidate.email}
                            disabled={isInviteSend}
                            onChange={(e) => handleCandidateEmailFormChange(e, i)}
                          />
                          {candidate.status && candidate.status === "success" && (
                            <>
                              <p className="invite__success">Invite sent</p>
                            </>
                          )}

                          {candidate.status &&
                            candidate.status ===
                            "not elligible due to skill test interval" && (
                              <>
                                <p className="invite__error">
                                  Candidate has recently taken a test.
                                </p>
                              </>
                            )}
                          {candidate.status &&
                            candidate.status === "existinginvite" && (
                              <>
                                <p className="invite__error">
                                  The candidate already has an active test invite.
                                </p>
                              </>
                            )}

                          {candidate.status &&
                            candidate.status === "The candidate has already taken the test." && (
                              <>
                                <p className="invite__error">
                                  The candidate has already taken this test.
                                </p>
                              </>
                            )}

                          {candidate.status &&
                            candidate.status === "The candidate has already taken the test. Please ask the candidate to share the PoweResume" && (
                              <>
                                <p className="invite__error">
                                  The candidate has already taken this test. Please
                                  ask the candidate to share the PoweResume with
                                  you.
                                </p>
                              </>
                            )}
                          {candidate.status &&
                            candidate.email === "" && (
                              <>
                              </>
                            )}
                          {candidate.status &&
                            candidate.status === "existinginvite" && !candidate.email === "" && (
                              <>
                                <p className="invite__error">
                                  The candidate has an active invite for a test.
                                </p>
                              </>
                            )}
                          {candidate.status &&
                            candidate.status ===
                            "the candidate already reached the skill test limit" && (
                              <>
                                <p className="invite__error">
                                  This candidate has reached the skill test limit. Please ask them to delete an existing test using the 'Take Skill Test' button in PoweResume.
                                </p>
                              </>
                            )}
                          {candidate.status &&
                            candidate.status ===
                            "Email ID already registered as a Recruiter. Please use a different Email ID." && (
                              <>
                                <p className="invite__error">
                                  Email ID already registered as a Recruiter. Please
                                  use a different Email ID.
                                </p>
                              </>
                            )}
                        </div>
                        <div className="select customized-select dropdown_width_recruiter_invite">
                          <input
                            type="text"
                            className={!candidate.firstNameHighlight ? "text_box_cleartalent_form_recruiter mt_8" : "text_box_cleartalent_form_recruiter_highlighter mt_8"}
                            name="firstName"
                            placeholder="Enter First Name"
                            value={candidate?.firstName}
                            disabled={candidate?.disableFirstName || isInviteSend}
                            onChange={(e) => handleCandidateFormChange(e, i)}
                          />
                        </div>
                        <div className="select customized-select dropdown_width_recruiter_invite">
                          <input
                            type="text"
                            className={!candidate.lastNameHighlight ? "text_box_cleartalent_form_recruiter mt_8" : "text_box_cleartalent_form_recruiter_highlighter mt_8"}
                            name="lastName"
                            placeholder="Enter Last Name"
                            value={candidate?.lastName}
                            disabled={candidate?.disableLastName || isInviteSend}
                            onChange={(e) => handleCandidateFormChange(e, i)}
                          />

                          {!candidate.status && (
                            <div >
                              <div className="closeIcon cp">
                                {((i !== 0) || (i === 0 && candidates.length > 1) || (bulkUploadClick && candidates.length > 2)) && (
                                  <CancelRoundedIcon
                                    onClick={() => closeExtraForm(i)}
                                  />
                                )}
                              </div>
                              <div className="invite_candidate_add_icon_wrap cp closeIcons">
                                {i === (candidates.length - 1) ? (
                                  <AddCircleIcon
                                    color="primary"
                                    onClick={bulkUploadClick ? (addMoreForm1) : (addMoreForm)}
                                  />
                                ) : ''}
                              </div>

                            </div >
                          )}
                        </div>
                      </div>
                    ))
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="bulk_drop_menu " >
              <div>
                {
                  bulkUploadClick ?
                    (
                      <Button variant="outlined" className="linkButton btn_styl " id="btn_border" disabled={isInviteSend} onClick={bulk_upload_conf}>
                        <p className="bulk_upload reset_email">
                          Reset
                        </p>
                      </Button>
                    ) : (
                      <FilePicker
                        extensions={["xlsx"]}
                        onChange={(e) => handelExcel(e)}
                        onError={(errMsg) => {
                          NotificationManager.error(
                            errMsg,
                            "Error", 10000
                          );
                        }}
                      >
                        <Button variant="outlined" className="linkButton " disabled={isInviteSend}>
                          <p className="bulk_upload">
                            Bulk Upload
                          </p>
                        </Button>
                      </FilePicker>
                    )
                }
              </div>
              <div className="dropButton mt_5">
                <a href="/Bulk_Upload_Template.xlsx" className="sample_file" id="center_Aling"> <span id="downTemp"><GetAppIcon /></span><span>Download Template </span></a>
              </div>
              <div>
                <button
                  type="button"
                  className="btn-invite_submit btn-invite_submit_blue cp submit_btn_ivt"
                  onClick={handleSendInviteCandidate}
                  disabled={
                    isInviteSend || submitloader || !candidates.some((c) => c.firstName !== "" || c.lastName !== "" || c.email !== "")
                  }
                >
                  {submitloader && (
                    <CircularProgress size={18} color="inherit" />
                  )}
                  {submitloader ? "Sending invite..." : "Send Invite"}
                </button>

                {isInviteSend && (
                  <button
                    type="button"
                    className="btn-invite_submit btn-invite_submit_blue cp ml_25  "
                    onClick={() => formReset()}
                  >
                    Invite More
                  </button>
                )}
              </div>
            </div>
            {/* } */}
          </div>
        </>
      ) : (
        <UnauthorizedAccess />
      )
      }
      <Dialog
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
        open={confirmDeleteModal}
        onClose={bulk_upload_cls}
      >
        <DialogTitle>

        </DialogTitle>
        <DialogContent className='support_con'>
          <div className='support_header'>
            <p className="fs-semi-bold fs-16 f-color">
              Are you sure you want to reset ?
            </p>

          </div>
        </DialogContent>
        <DialogActions sx={styleSx.buttonForSupport} >
          <Button sx={styleSx.btnCancel} id="buton" onClick={bulk_upload_cls}>No</Button>
          <Button sx={styleSx.btnSave} id="buton" onClick={(e) => bulk_upload_clr()}
          >Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InviteCandidates;

